import OpeningSlideSettings from "./OpeningSlideSettings";

export default function StylingSettings({ styleSettings, handleStyleChange }) {
  return (
    <>
      <OpeningSlideSettings
        styleSettings={styleSettings}
        handleStyleChange={handleStyleChange}
      />
    </>
  );
}
